import React from "react";

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="inner">
          <div className="footer__logo"></div>
          <p className="footer__copy">
            Copyright © SALIN. All rights reserved.
          </p>
          <div className="footer__info">
            <address>
              <span>+82-070-7708-0958</span>
              <span>
                <a href="mailto:repl@salin.co.kr?subject=레디플레이 문의 드립니다.">
                  repl@salin.co.kr
                </a>
                <br />
              </span>
            </address>
          </div>
        </div>
        <button className="scrollToTopBtn" title="Back To Top">
          <ion-icon name="arrow-up-outline"></ion-icon>
        </button>
      </footer>
    </>
  );
};

export default Footer;
